import { Next } from '@securitize/ui-components';

export const getInvestorDocumentsNext = new Next('/documents', 'GET_INVESTOR_DOCUMENTS');
